import React, { useState, useEffect, useCallback, useRef } from 'react';
import './Approvals.css';
import '../App.css';
import Header from "../Header/Header.jsx";
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import BootstrapTable from 'react-bootstrap-table-next';
import { Button, Jumbotron } from "react-bootstrap";
import { withTranslation } from 'react-i18next';
import { MdRefresh, MdClose } from "react-icons/md";
import paginationFactory, {
    PaginationListStandalone,
    PaginationProvider,
    SizePerPageDropdownStandalone
} from 'react-bootstrap-table2-paginator';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import { Redirect } from "react-router-dom";
import ThemeService from '../../services/ThemeService';
import Utils from '../../services/Utils';
import EmptyDocsPanel from '../EmptyDocsPanel/EmptyDocsPanel';
import SearchBar from './SearchBar/SearchBar';
import SigningProcessModal from '../Modals/SigningProcessModal';
import LoadingCircle from '../LoadingCircle';
import documentRenderService from '../../services/documentRender/documentRenderService';
import TagsList from './TagsList/TagsList';
import ToastComponent from '../Toast/Toast';
import ApprovalPreview from '../ApprovalPreview/ApprovalPreview.jsx';
import ApprovalService from '../../services/Approval/ApprovalService';

import warning from '../../assets/icons/warning-jumbotron.png';
import { useDispatch, useSelector } from 'react-redux';
import ApprovalsActionTypes from '../../redux/approvals/approvals.types';

const ipLocation = require("iplocation");
const publicIp = require('public-ip');

export const Approvals = ({ t }) => {
    const dispatch = useDispatch();
    const { pendingApprovals, pendingApprovalsBackup } = useSelector((state) => ({
        pendingApprovals: state.approvals.filteredApprovals,
        pendingApprovalsBackup: state.approvals.approvals
    }));

    const [language] = useState(localStorage.getItem('i18nextLng'));
    const [userToken] = useState(sessionStorage.getItem('userToken'));
    const [urlReturn] = useState(sessionStorage.getItem('urlReturn'));
    const [selection, setSelection] = useState({ docsSelected: [], approvalsSelectedGUID: [] });
    const docsSelected = selection.docsSelected;
    const approvalsSelectedGUID = selection.approvalsSelectedGUID;
    const [viewApproval, setViewApproval] = useState(false);
    const [loading, setLoading] = useState(true);
    const [sessionExpired, setSessionExpired] = useState(false);
    const [redirect, setRedirect] = useState(false);
    const [time, setTime] = useState(0);
    const [selectedApproval, setSelectedApproval] = useState({});
    const [renderedApproval, setRenderedApproval] = useState({
        pages: [],
        totalPages: 0,
        nextPage: 1
    });
    const [rejectedDoc, setRejectedDoc] = useState(false);
    const [signedDoc, setSignedDoc] = useState(false);
    const [redirecting, setRedirecting] = useState(false);
    const [tokenExpired, setTokenExpired] = useState(false);
    const [loadingApprovalProcess, setLoadingApprovalProcess] = useState(false);
    const [showError, setShowError] = useState(false);
    const [errorData, setErrorData] = useState('');
    const [errorType, setErrorType] = useState('');
    const [docsApproved, setDocsApproved] = useState(0);
    const [userIsLoggedByAuthCerts, setUserIsLoggedByAuthCerts] = useState(false);
    const [showJumbotron, setShowJumbotron] = useState(true);
    const [documentInfo] = useState({});
    const [documentSigners, setDocumentSigners] = useState([]);
    const [documentAttatchmentsList] = useState([]);
    const [docsAttachedRendered] = useState([]);
    const [currentPageTable, setCurrentPageTable] = useState(1);
    const [currentSizePerPageTable, setCurrentSizePerPageTable] = useState(10);
    const [, setCurrentSort] = useState({ order: "asc", field: "FileName" });
    const [loadingMorePages, setLoadingMorePages] = useState(false);
    const [previouslyRejectedDoc, setPreviouslyRejectedDoc] = useState(false);
    const [showAdvancedSearch, setShowAdvancedSearch] = useState(true);
    const [nextDocument, setNextDocument] = useState({});

    const timerRef = useRef(null);
    const getPendingApprovalsRef = useRef(() => {});

    const appendZero = useCallback((value) => {
        return value >= 10 ? value : `0${value}`;
    }, []);

    const formatDate = useCallback((date) => {
        let hours = date.getHours();
        const moment = hours >= 12 ? "PM" : "AM";
        hours = hours > 12 ? hours - 12 : hours;
        const formattedDate = [
            appendZero(date.getMonth() + 1),
            appendZero(date.getDate()),
            date.getFullYear()
        ].join('/') + ' ' +
        [appendZero(hours), appendZero(date.getMinutes()), appendZero(date.getSeconds())].join(':') + ' ' + moment;
        return formattedDate;
    }, [appendZero]);

    const startTimer = useCallback(() => {
        timerRef.current = setInterval(() => {
            setTime((tPrev) => tPrev + 1);
        }, 60000);
    }, []);

    const getViDMobileUserGUIDFromOauthToken = useCallback(() => {
        const oauthTokenB64 = sessionStorage.getItem('oauthTokenB64');
        if (!oauthTokenB64) return '';
        const tokenParts = oauthTokenB64.split(".");
        const jsonTokenInfo = atob(tokenParts[1]);
        const tokenInfo = JSON.parse(jsonTokenInfo);
        return tokenInfo.sub;
    }, []);

    const sortList = useCallback((list, field = "FileName", order = "asc") => {
        const sorted = [].concat(list).sort((a, b) => {
            return ('' + a[field]).localeCompare(b[field]);
        });
        return order === "asc" ? sorted : sorted.reverse();
    }, []);

    const handleSessionExpiredError = useCallback((status) => {
        if (status === 401) {
            setSessionExpired(true);
            startTimer();
        }
    }, [startTimer]);

    const handleGenericError = useCallback((error) => {
        handleSessionExpiredError(error.response?.status);
        if (error.response?.status !== 401) {
            setErrorType(error.response.status);
            setErrorData(error.response.data);
            setShowError(true);
        }
    }, [handleSessionExpiredError]);

    const clearVariablesToRenderListProperly = useCallback(() => {
        setRenderedApproval({ pages: [], totalPages: 0, nextPage: 1 });
        setSelectedApproval({});
        setSelection({ docsSelected: [], approvalsSelectedGUID: [] });
    }, []);

    const getCurrentTablePage = useCallback((pendingApprovalsList, approverGuid, sizePerPage, isLastDocumentSelected, selectedDocs) => {
        const lastAddedApproverGuidIndex = pendingApprovalsList.findIndex((doc) => doc.ApproverGuid === approverGuid);
        let firstAddedApproverGuidIndex;
        if (isLastDocumentSelected) {
            const firstDocSelected = selectedDocs[0];
            firstAddedApproverGuidIndex = pendingApprovalsList.findIndex((doc) => doc.ApproverGuid === firstDocSelected.ApproverGuid);
        }
        const docIndexToBeFound = isLastDocumentSelected ? firstAddedApproverGuidIndex : lastAddedApproverGuidIndex;
        const module = docIndexToBeFound % sizePerPage;
        const page = Math.ceil(docIndexToBeFound / sizePerPage);
        return module === 0 ? page + 1 : page;
    }, []);

    const selectDocument = useCallback((row, isLastDocumentSelected = false) => {
        setSelection((prev) => {
            const newApprovalsSelectedGUID = prev.approvalsSelectedGUID.indexOf(row.ApproverGuid) === -1
                ? [...prev.approvalsSelectedGUID, row.ApproverGuid]
                : prev.approvalsSelectedGUID;
            const newDocsSelected = prev.docsSelected.find((doc) => doc.ApproverGuid === row.ApproverGuid) === undefined
                ? [...prev.docsSelected, row]
                : prev.docsSelected;
            if (newApprovalsSelectedGUID.length > 0) {
                const newPage = getCurrentTablePage(pendingApprovals, row.ApproverGuid, currentSizePerPageTable, isLastDocumentSelected, newDocsSelected);
                setCurrentPageTable(newPage);
            }
            sessionStorage.setItem('approvalsSelectedGUIDString', newApprovalsSelectedGUID.toString());
            return { docsSelected: newDocsSelected, approvalsSelectedGUID: newApprovalsSelectedGUID };
        });
        return true;
    }, [pendingApprovals, currentSizePerPageTable, getCurrentTablePage]);

    const unselectDocuments = useCallback((rows) => {
        setSelection((prev) => {
            let newDocsSelected = prev.docsSelected;
            let newApprovalsSelectedGUID = prev.approvalsSelectedGUID;
            rows.forEach((row) => {
                newDocsSelected = newDocsSelected.filter((doc) => doc.ApproverGuid !== row.ApproverGuid);
                newApprovalsSelectedGUID = newApprovalsSelectedGUID.filter((approverGuid) => approverGuid !== row.ApproverGuid);
            });
            sessionStorage.setItem('approvalsSelectedGUIDString', newApprovalsSelectedGUID.toString());
            return { docsSelected: newDocsSelected, approvalsSelectedGUID: newApprovalsSelectedGUID };
        });
    }, []);

    const setPendingSignaturesSavedInSession = useCallback(() => {
        const docsSelectedGuiDdString = sessionStorage.getItem('approvalsSelectedGUIDString');
        const enabledDocsIteration = docsSelectedGuiDdString !== null && docsSelectedGuiDdString !== "";

        if (enabledDocsIteration && pendingApprovalsBackup?.length) {
            const vapprovalsSelectedGUID = docsSelectedGuiDdString.split(",");
            const filteredPendinSignatures = pendingApprovalsBackup.filter((doc) =>
                vapprovalsSelectedGUID.includes(doc.ApproverGuid)
            );
            const newApprovalsSelectedGUID = filteredPendinSignatures.map((doc) => doc.ApproverGuid);
            const newDocsSelected = [...filteredPendinSignatures];
            setSelection({ docsSelected: newDocsSelected, approvalsSelectedGUID: newApprovalsSelectedGUID });
            sessionStorage.setItem('approvalsSelectedGUIDString', newApprovalsSelectedGUID.toString());
            if (filteredPendinSignatures.length > 0) {
                const firstDoc = filteredPendinSignatures[0];
                const newPage = getCurrentTablePage(
                    pendingApprovalsBackup,
                    firstDoc.ApproverGuid,
                    currentSizePerPageTable,
                    filteredPendinSignatures.length === 1,
                    newDocsSelected
                );
                setCurrentPageTable(newPage);
            }
        }
        setLoading(false);
    }, [pendingApprovalsBackup, currentSizePerPageTable, getCurrentTablePage]);

    const viewApprovalHandler = useCallback(() => {
        clearVariablesToRenderListProperly();
        setPendingSignaturesSavedInSession();
        setViewApproval(false);
    }, [clearVariablesToRenderListProperly, setPendingSignaturesSavedInSession]);

    const showRejectedDocHandler = useCallback(() => {
        const approverGuid = selectedApproval?.ApproverGuid;
        if (approverGuid) {
            dispatch({
                type: ApprovalsActionTypes.DELETE_APPROVAL_FROM_LIST,
                payload: approverGuid,
            });
        }
        clearVariablesToRenderListProperly();
        setPendingSignaturesSavedInSession();
        setRejectedDoc(true);
        setViewApproval(false);
    }, [selectedApproval, dispatch, clearVariablesToRenderListProperly, setPendingSignaturesSavedInSession]);

    const showApprovedDocHandler = useCallback(() => {
        const approverGuid = selectedApproval?.ApproverGuid;
        if (approverGuid) {
            dispatch({
                type: ApprovalsActionTypes.DELETE_APPROVAL_FROM_LIST,
                payload: approverGuid,
            });
        }
        clearVariablesToRenderListProperly();
        setPendingSignaturesSavedInSession();
        setSignedDoc(true);
        setViewApproval(false);
    }, [selectedApproval, dispatch, clearVariablesToRenderListProperly, setPendingSignaturesSavedInSession]);

    const doLogOut = useCallback(() => {
        if (typeof userToken !== "undefined" && userToken === "true" && typeof urlReturn !== "undefined" && urlReturn !== "null" && urlReturn !== "") {
            setRedirecting(true);
            setTimeout(() => {
                window.location.href = atob(urlReturn);
            }, 3000);
        } else {
            setRedirect(true);
        }
        sessionStorage.clear();
    }, [userToken, urlReturn]);

    const isSelectAllHidden = useCallback(() => {
        if (!pendingApprovalsBackup || pendingApprovalsBackup.length === 0) return true;
        return false;
    }, [pendingApprovalsBackup]);

    const handleOnSelect = useCallback((row, isSelect) => {
        if (isSelect) {
            return selectDocument(row);
        }
        unselectDocuments([row]);
    }, [selectDocument, unselectDocuments]);

    const handleOnSelectAll = useCallback((isSelect, rows) => {
        if (isSelect) {
            rows.forEach((row, i) => selectDocument(row, i === rows.length - 1));
            return;
        }
        unselectDocuments(rows);
    }, [selectDocument, unselectDocuments]);

    const getDocumentInfo = useCallback(() => {
        const approverGuid = pendingApprovals?.length === 1
            ? pendingApprovals[0].ApproverGuid
            : selectedApproval?.ApproverGuid;
        return ApprovalService.getDocumentInfo(approverGuid)
            .then((res) => res.data)
            .catch((error) => {
                handleGenericError(error);
                throw error;
            });
    }, [selectedApproval, pendingApprovals, handleGenericError]);

    const handlePreviouslyRejectedDocError = useCallback((error, isSigning = false) => {
        if (error.response?.status !== 409) return;
        if (isSigning) {
            setTimeout(() => {
                setViewApproval(false);
                setSelectedApproval({});
                getPendingApprovalsRef.current();
            }, 3000);
            return;
        }
        setPreviouslyRejectedDoc(true);
        setSelectedApproval({});
    }, []);

    const getDocumentInfoAndAttachments = useCallback(() => {
        getDocumentInfo()
            .then((res) => {
                if (res) {
                    const documentSignersData = res.Signers || [];
                    for (let i = 0; i < documentSignersData.length; i++) {
                        const fullUTCUploadTime = res.UploadTime + ' UTC';
                        const localeUploadTime = new Date(fullUTCUploadTime);
                        documentSignersData[i].UploadTime = formatDate(localeUploadTime);
                        if (documentSignersData[i].OperationTime) {
                            const fullUTCOperationTime = documentSignersData[i].OperationTime + ' UTC';
                            const localeOperationTime = new Date(fullUTCOperationTime);
                            documentSignersData[i].OperationTime = formatDate(localeOperationTime);
                        }
                    }
                    setDocumentSigners(documentSignersData);
                }
            })
            .catch((error) => {
                handleSessionExpiredError(error.response?.status);
                handlePreviouslyRejectedDocError(error);
                setLoading(false);
            });
    }, [getDocumentInfo, formatDate, handleSessionExpiredError, handlePreviouslyRejectedDocError]);

    const renderDocument = useCallback(() => {
        const { pages, nextPage } = renderedApproval;
        const documentsList = pendingApprovals || [];

        if (loadingMorePages || nextPage === -1) return;

        let approverGuid = selectedApproval?.ApproverGuid;
        let ApproverGuid = selectedApproval?.ApproverGuid;

        if (pendingApprovals?.length === 1) {
            approverGuid = pendingApprovals[0].ApproverGuid;
            ApproverGuid = pendingApprovals[0].ApproverGuid;
        }

        const index = documentsList.findIndex((doc) => doc.ApproverGuid === approverGuid);
        if (index >= 0 && index < documentsList.length - 1) {
            setNextDocument(documentsList[index + 1]);
        }

        if (pages.length > 0) setLoadingMorePages(true);

        documentRenderService.renderApprovalDocumentPages(ApproverGuid, nextPage)
            .then((response) => {
                const data = response.data;
                const pagesData = pages.concat(data.DocPageRendered);
                const totalPdfPagesNumber = data.NumberOfPages;
                const nextPageToRender = data.NextPage;
                setLoadingMorePages(false);
                setLoading(false);
                setRenderedApproval({
                    pages: pagesData,
                    nextPage: nextPageToRender,
                    totalPages: totalPdfPagesNumber
                });
            })
            .catch((error) => {
                handleSessionExpiredError(error?.response?.status);
                setLoadingMorePages(false);
                setLoading(false);
            });

        getDocumentInfoAndAttachments();
    }, [
        renderedApproval,
        loadingMorePages,
        selectedApproval,
        pendingApprovals,
        handleSessionExpiredError,
        getDocumentInfoAndAttachments
    ]);

    const getPendingApprovals = useCallback(() => {
        clearVariablesToRenderListProperly();
        setLoading(true);

        const searchBody = {
            Terms: { vidmobileuser: getViDMobileUserGUIDFromOauthToken() }
        };

        ApprovalService.searchApprovals(searchBody)
            .then((res) => {
                if (res) {
                    const pendingApprovalsData = res.data;
                    dispatch({
                        type: ApprovalsActionTypes.ADD_APPROVALS_TO_LIST,
                        payload: sortList(pendingApprovalsData)
                    });
                    if (pendingApprovalsData.length === 1) {
                        setViewApproval(true);
                        setSelectedApproval(pendingApprovalsData[0]);
                        setLoading(true);
                        return;
                    }
                    setPendingSignaturesSavedInSession();
                }
            })
            .catch((error) => {
                if (error.response && error.response.status === 401) {
                    if (typeof userToken !== "undefined" && userToken === "true" && typeof urlReturn !== "undefined" && urlReturn !== "null" && urlReturn !== "") {
                        setTokenExpired(true);
                        setTimeout(() => {
                            window.location.href = atob(urlReturn);
                        }, 3000);
                    } else {
                        setSessionExpired(true);
                        startTimer();
                    }
                }
                if (error.response && error.response.status === 404) {
                    if (typeof userToken !== "undefined" && userToken === "true" && typeof urlReturn !== "undefined" && urlReturn !== "null" && urlReturn !== "") {
                        setRedirecting(true);
                        setTimeout(() => {
                            window.location.href = atob(urlReturn);
                        }, 3000);
                        sessionStorage.clear();
                    }
                }
                setLoading(false);
                clearVariablesToRenderListProperly();
            });
    }, [
        clearVariablesToRenderListProperly,
        userToken,
        urlReturn,
        getViDMobileUserGUIDFromOauthToken,
        sortList,
        dispatch,
        startTimer,
        setPendingSignaturesSavedInSession
    ]);

    getPendingApprovalsRef.current = getPendingApprovals;

    const selectedApproverGuid = selectedApproval?.ApproverGuid;
    useEffect(() => {
        if (viewApproval && selectedApproverGuid && loading) {
            renderDocument();
        }
    }, [viewApproval, selectedApproverGuid, loading, renderDocument]);

    const seeDocument = useCallback((e, row) => {
        e.stopPropagation();
        setViewApproval(true);
        setSelectedApproval(row);
        setLoading(true);
    }, []);

    const seeNextApproval = useCallback((e) => {
        setRenderedApproval({ pages: [], totalPages: 0, nextPage: 1 });
        e.stopPropagation();
        setViewApproval(true);
        setSelectedApproval(nextDocument);
        setLoading(true);
    }, [nextDocument]);

    const getClientData = useCallback(() => {
        (async () => {
            try {
                const ip = await publicIp.v4();
                await ipLocation(ip);
            } catch (err) {
                console.error(err);
            }
        })();
    }, []);

    const onPageChange = useCallback((page) => {
        setCurrentPageTable(page);
    }, []);

    const onSizePerPageChange = useCallback((sizePerPage, page) => {
        setCurrentSizePerPageTable(sizePerPage);
        setCurrentPageTable(1);
    }, []);

    const shouldHideTagColumn = useCallback(() => {
        if (!pendingApprovalsBackup || pendingApprovalsBackup.length === 0) return true;
        return pendingApprovalsBackup.every((doc) => doc.Tag === "");
    }, [pendingApprovalsBackup]);

    const handleBatchApproval = useCallback(() => {
        setLoadingApprovalProcess(true);
        let totalSigned = 0;
        docsSelected.forEach(async (document) => {
            const { ApproverGuid } = document;
            const body = {};
            await ApprovalService.acceptApproval(ApproverGuid, body);
            totalSigned = totalSigned + 1;
            setDocsApproved(totalSigned);
            dispatch({
                type: ApprovalsActionTypes.DELETE_APPROVAL_FROM_LIST,
                payload: ApproverGuid,
            });
            if (totalSigned === docsSelected.length) {
                setLoadingApprovalProcess(false);
                setSelection({ docsSelected: [], approvalsSelectedGUID: [] });
                setSignedDoc(true);
                setCurrentPageTable(1);
            }
        });
    }, [docsSelected, dispatch]);

    useEffect(() => {
        Utils.appendScript("/assets/js/autoscript.js");
        Utils.appendScript("/assets/js/forge.min.js");
        getClientData();
        ThemeService.setTheme();
        const authCerts = sessionStorage.getItem('authCerts');
        if (authCerts !== null) {
            setUserIsLoggedByAuthCerts(true);
        }
        getPendingApprovals();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const renderRefreshApprovalsButton = () => (
        <MdRefresh className="refresh-button" onClick={() => getPendingApprovals()} />
    );

    if (redirect) {
        return <Redirect to={{ pathname: '/' }} />;
    }

    if (userIsLoggedByAuthCerts) {
        return <Redirect to={{ pathname: '/authcerts' }} />;
    }

    const selectRow = {
        mode: 'checkbox',
        hideSelectAll: isSelectAllHidden(),
        clickToSelect: true,
        selectColumnStyle: { verticalAlign: "middle" },
        onSelect: handleOnSelect,
        onSelectAll: handleOnSelectAll,
        selected: approvalsSelectedGUID
    };

    const defaultSorted = [{ dataField: 'FileName', order: 'asc' }];

    const columns = [
        {
            dataField: 'SignerName',
            text: t('approvals.signer-name'),
            align: 'left',
            sort: true,
            headerAlign: 'left',
            headerClasses: 'documents-headerClass1',
            style: { verticalAlign: 'middle' },
            onSort: (field, order) => setCurrentSort({ order, field })
        },
        {
            dataField: 'FileName',
            text: t('documents.document'),
            align: 'left',
            sort: true,
            headerAlign: 'left',
            headerClasses: 'documents-headerClass1',
            style: { verticalAlign: 'middle' },
            onSort: (field, order) => setCurrentSort({ order, field })
        },
        {
            dataField: 'Date',
            text: t('documents.sent'),
            align: 'left',
            sort: true,
            headerAlign: 'left',
            headerClasses: 'documents-headerClass2',
            style: { verticalAlign: 'middle' },
            formatter: (cellContent, row) => {
                const datetime = row?.UploadTime;
                let date = '';
                if (datetime) date = datetime.split(" ")[0];
                return date;
            }
        },
        {
            dataField: 'Tag',
            text: t('documents.tag'),
            align: 'left',
            sort: true,
            headerAlign: 'left',
            headerClasses: 'documents-headerClass2',
            style: { verticalAlign: 'middle' },
            hidden: shouldHideTagColumn(),
            formatter: (cellContent, row) => <TagsList tagString={row?.Tag} />
        },
        {
            dataField: 'ActionButton',
            text: "",
            align: 'center',
            headerAlign: 'left',
            isDummyField: true,
            style: { verticalAlign: 'middle' },
            headerClasses: 'documents-headerClass3',
            formatter: (cellContent, row, rowIndex) => (
                <Button
                    type="button"
                    id={row?.ApproverGuid}
                    className="btn btn-primary btn-table"
                    onClick={(e) => seeDocument(e, row)}
                >
                    {t('documents.see')}
                </Button>
            )
        }
    ];

    const paginationOptions = {
        custom: true,
        totalSize: pendingApprovals ? pendingApprovals.length : 0,
        page: currentPageTable,
        paginationSize: 3,
        pageStartIndex: 1,
        firstPageText: t('general.first'),
        prePageText: t('general.pre'),
        nextPageText: t('general.next'),
        lastPageText: t('general.last'),
        nextPageTitle: t('general.first-page'),
        prePageTitle: t('general.pre-page'),
        firstPageTitle: t('general.next-page'),
        lastPageTitle: t('general.last-page'),
        sizePerPageList: [
            { text: '10', value: 10 },
            { text: '30', value: 30 },
            { text: '50', value: 50 },
            { text: t('general.all'), value: pendingApprovals ? pendingApprovals.length : 0 }
        ],
        onPageChange,
        onSizePerPageChange
    };

    const contentTable = ({ paginationProps, paginationTableProps }) => (
        <div>
            <ToolkitProvider
                keyField='ApproverGuid'
                data={pendingApprovals}
                columns={columns}
                search={false}
                bootstrap4
            >
                {(toolkitprops) => (
                    <div>
                        <BootstrapTable
                            striped
                            hover
                            condensed
                            bordered={false}
                            selectRow={selectRow}
                            defaultSorted={defaultSorted}
                            {...toolkitprops.baseProps}
                            {...paginationTableProps}
                        />
                    </div>
                )}
            </ToolkitProvider>
            <div className="table-pagination-container">
                <SizePerPageDropdownStandalone {...paginationProps} className={'page-dropdown'} />
                <PaginationListStandalone {...paginationProps} />
            </div>
        </div>
    );

    const timeText = language === 'es' ? 'Hace ' + time + ' minutos' : language === 'en' ? time + ' minutes ago' : language === 'ca' ? 'Fa ' + time + ' minuts' : 'Hace ' + time + ' minutos';
    const { pages, totalPages } = renderedApproval;

    return (
        <div className="documents-container">
            {rejectedDoc && (
                <ToastComponent
                    onClose={() => setRejectedDoc(false)}
                    show={rejectedDoc}
                    autohide
                    delay={3000}
                    title={t('general.rejected')}
                    message={t('general.rejected-text')}
                    variant="error"
                    zIndex={10}
                />
            )}
            {signedDoc && (
                <ToastComponent
                    onClose={() => setSignedDoc(false)}
                    show={signedDoc}
                    autohide
                    delay={3000}
                    title={t('approvals.approved-documents')}
                    message={t('approvals.approved-success')}
                    variant="success"
                    zIndex={10}
                />
            )}
            {redirecting && (
                <ToastComponent
                    onClose={() => setRedirecting(false)}
                    show={redirecting}
                    autohide
                    delay={3000}
                    title={t('general.exit')}
                    message={t('general.exit-text')}
                    variant="info"
                    zIndex={10}
                />
            )}
            {tokenExpired && (
                <ToastComponent
                    onClose={() => setTokenExpired(false)}
                    show={tokenExpired}
                    autohide
                    delay={3000}
                    title={t('general.exit')}
                    message={t('general.exit-text2')}
                    variant="warning"
                    zIndex={10}
                />
            )}
            {showError && (
                <ToastComponent
                    onClose={() => setShowError(false)}
                    show={showError}
                    title={<>{t('general.error')} {errorType}</>}
                    message={errorData}
                    variant="error"
                    closeButton
                    zIndex={15}
                />
            )}
            {previouslyRejectedDoc && (
                <ToastComponent
                    onClose={() => {
                        getPendingApprovals();
                        setPreviouslyRejectedDoc(false);
                        setViewApproval(false);
                    }}
                    show={previouslyRejectedDoc}
                    title={t('general.error')}
                    message={t('general.rejected')}
                    variant="error"
                    closeButton
                />
            )}
            {sessionExpired && (
                <ToastComponent
                    show={sessionExpired}
                    title={t('general.notification')}
                    subtitle={timeText}
                    variant="session-expired"
                    zIndex={10}
                    closeButton={false}
                >
                    <p>{t('general.session-expired')}</p>
                    <Button
                        type="button"
                        className="btn btn-primary"
                        id="sign-all-docs"
                        onClick={() => doLogOut()}
                    >
                        {t('general.accept')}
                    </Button>
                </ToastComponent>
            )}
            <Header />
            {(!viewApproval && showJumbotron) && (
                <Jumbotron>
                    <MdClose className="close-jumbotron" onClick={() => setShowJumbotron(!showJumbotron)} />
                    <div className="jumbotron-content">
                        <img src={warning} alt="Warning icon" />
                        <p>
                            {t('approvals.pending')}. {t('approvals.check')}
                        </p>
                    </div>
                </Jumbotron>
            )}
            {loadingMorePages && (
                <div className="loading-more-container">
                    <LoadingCircle />
                </div>
            )}
            {(!loading && !viewApproval && pendingApprovalsBackup?.length > 0) && (
                <div className="documents-table-container">
                    <SigningProcessModal
                        showModal={loadingApprovalProcess}
                        showProcess={true}
                        signedDocs={docsApproved}
                        selectedDocs={docsSelected.length}
                        isApprovals
                    />
                    <SearchBar
                        updateState={(newState) => {
                            if (newState.showAdvancedSearch !== undefined) setShowAdvancedSearch(newState.showAdvancedSearch);
                            if (newState.currentPageTable !== undefined) setCurrentPageTable(newState.currentPageTable);
                        }}
                        showTag={!shouldHideTagColumn()}
                        approvalsSelectedGUID={approvalsSelectedGUID}
                        showAdvancedSearch={showAdvancedSearch}
                        setShowAdvancedSearch={setShowAdvancedSearch}
                    >
                        {renderRefreshApprovalsButton()}
                    </SearchBar>
                    <PaginationProvider pagination={paginationFactory(paginationOptions)}>
                        {contentTable}
                    </PaginationProvider>
                    <div className='button-container'>
                        <Button
                            type="button"
                            disabled={approvalsSelectedGUID.length === 0 || null}
                            className={approvalsSelectedGUID.length === 0 || null ? "btn btn-primary button-disabled" : "btn btn-primary"}
                            id="sign-all-docs"
                            onClick={() => handleBatchApproval()}
                        >
                            {t('approvals.approve-selected')}
                        </Button>
                    </div>
                </div>
            )}
            {(!loading && !viewApproval && (!pendingApprovalsBackup || pendingApprovalsBackup.length === 0)) && (
                <EmptyDocsPanel isApprovals onClickGetPendingDocuments={getPendingApprovals} />
            )}
            {loading && <LoadingCircle centerVertically={true} />}
            {(viewApproval && pages?.length > 0) && (
                <ApprovalPreview
                    renderedApproval={pages}
                    selectedApproval={selectedApproval}
                    pendingApprovals={pendingApprovals}
                    documentInfo={documentInfo}
                    documentSigners={documentSigners}
                    documentAttatchmentsList={documentAttatchmentsList}
                    attDocArray={undefined}
                    docsAttachedRendered={docsAttachedRendered}
                    viewApprovalHandler={viewApprovalHandler}
                    showRejectedDocHandler={showRejectedDocHandler}
                    showApprovedDocHandler={showApprovedDocHandler}
                    totalPages={totalPages}
                    renderDocument={renderDocument}
                    handlePreviouslyRejectedDocError={handlePreviouslyRejectedDocError}
                    seeNextApproval={seeNextApproval}
                    checkedApprovals={approvalsSelectedGUID}
                    updateSelectedApprovals={handleOnSelect}
                />
            )}
        </div>
    );
};

export default withTranslation()(Approvals);
